import React from 'react';
import { FaTrashAlt } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from "../../redux/AuthSlice";
import { handleAPIRequest } from '../../api/api';

const Lsidebar = ({ 
  companies, 
  setCompanies, // ✅ Receive setCompanies from HomePage
  onAddCompanyClick, 
  onCompanySelect, 
  token, 
  selectedCompanyId, 
  setSelectedCompanyId, 
  isSidebarOpen,
  setIsSidebarOpen,
  resetForm
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCompanySelect = (company) => {
    if (company) {
    
        setSelectedCompanyId(company.id);
        onCompanySelect(company);
    }
  };

  const handleDeleteCompany = async (companyId) => {

    try {
      const response = await handleAPIRequest('delete', `delete-company-details/${companyId}`, null, null, token);

      if (response.status === 200)
      {

      
      Swal.fire({
        title: 'Deleted!',
        text: response.data.message,
        icon: 'success',
        confirmButtonColor: '#3085d6',
      });

      setCompanies((prev) => prev.filter((company) => company.id !== companyId)); 
      resetForm();
    }
    else{
      Swal.fire({
        title: 'Error!',
        text: 'Error deleting the company.',
        icon: 'error',
        confirmButtonColor: '#d33',
      });
    }
    } catch (error) {
      const errorMessage = error?.message || error.toString();
    
      if (errorMessage.includes("401")) {
        alert("Session Expired");
        dispatch(logout());
        navigate("/");
        return;
      }

    
      console.error('Error deleting the company:', error);
    }
  };


  const handleLogoutApi = async (companyId) => {

    try {
      const response = await handleAPIRequest('post', `logout`, null, null, token);
        dispatch(logout());
        navigate('/');
    } catch (error) {
      const errorMessage = error?.message || error.toString();
    
      if (errorMessage.includes("401")) {
        alert("Session Expired");
        dispatch(logout());
        navigate("/");
        return;
      }

    
      console.error('Error deleting the company:', error);
    }
  };
  const confirmDeleteCompany = (companyId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "This action cannot be undone!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteCompany(companyId);
      }
    });
  };

  const handleLogout =  () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You will be logged out!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, Logout!'
    }).then((result) => {
      if (result.isConfirmed) {
      handleLogoutApi();
      }
    });
  };
  return (
    <div className={`fixed top-0 left-0 h-screen bg-gray-800 text-white w-64 p-4 transition-transform duration-300 
      ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 z-50 flex flex-col`}>
  <button 
    onClick={() => setIsSidebarOpen(false)} 
    className="text-white text-xl absolute top-4 right-4 md:hidden"
  >
    ✖
  </button>

  <h2 className="text-xl font-bold text-center mt-4">Companies</h2>

  {/* <button 
    onClick={onAddCompanyClick}
    className="w-full py-2 bg-blue-500 hover:bg-blue-600 text-white font-bold rounded mt-4"
  >
    + Add New Company
  </button> */}

  <div className="flex-grow overflow-y-auto mt-4">
    {companies.length === 0 ? (
      <div className="text-center text-gray-400">No companies available. Please add one.</div>
    ) : (
      <ul className="space-y-3">
        {companies.map((company) => (
          <li
            key={company.id}
            className={`flex items-center justify-between p-3 rounded transition-colors 
              ${company.id === selectedCompanyId ? 'bg-gray-700' : 'bg-gray-600 hover:bg-gray-700'} 
              cursor-pointer`}
            onClick={() => handleCompanySelect(company)}
          >
            <span className="flex-1">{company.name}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                confirmDeleteCompany(company.id);
              }}
              className="text-red-400 hover:text-red-600"
            >
              <FaTrashAlt />
            </button>

            
          </li>
        ))}
      </ul>
    )}
  </div>

  <button 
    onClick={handleLogout} 
    className="w-full py-2 bg-red-500 hover:bg-red-600 text-white font-bold rounded mt-4"
  >
    Logout
  </button>
</div>

  );
};

export default Lsidebar;
